import {
  AvailableDocuments,
  DocumentForOrder,
  DocumentsState,
  SharedDocument,
  SharedDocumentForUser
} from './documents.model';

const reducers = {
  storeAvailableDocuments: (
    state: DocumentsState,
    availableDocuments: AvailableDocuments[]
  ) => ({
    ...state,
    availableDocuments
  }),
  storeSharedDocumentsForAgreement: (
    state: DocumentsState,
    sharedDocumentsForAgreement: SharedDocument[]
  ) => ({
    ...state,
    sharedDocumentsForAgreement
  }),
  storeDocumentsForOrder: (
    state: DocumentsState,
    documentsForOrder: DocumentForOrder[]
  ) => ({
    ...state,
    documentsForOrder
  }),
  storeSharedDocumentsForUser: (
    state: DocumentsState,
    sharedDocumentsForUser: SharedDocumentForUser[]
  ) => ({
    ...state,
    sharedDocumentsForUser
  })
};

export default reducers;
